export const state = () => ({
  formData: {},
  formOpen: false,
  formSubmitted: false,
});

export const mutations = {
  SET_FORM_DATA(localstate, data) {
    localstate.formData = data;
  },

  UPDATE_FIELD_DATA(localstate, { key, value }) {
    localstate.formData = { ...localstate.formData, [key]: value };
  },

  SET_FORM_OPEN(localstate, state) {
    localstate.formOpen = state;
  },

  SET_FORM_SUBMITTED(localstate, value) {
    localstate.formSubmitted = value;
  },

  RESET_FORM(localstate) {
    localstate.formData = {};
    localstate.formOpen = false;
    localstate.formSubmitted = false;
  },
};

export const actions = {
  setFormData({ commit }, data) {
    commit('SET_FORM_DATA', data);
  },

  updateFieldData({ commit }, data) {
    commit('UPDATE_FIELD_DATA', data);
  },

  setFormOpen({ commit }, { state, stackIndex }) {
    commit('SET_FORM_OPEN', state);

    if (!state && stackIndex !== undefined) {
      commit('chatbotStore/UPDATE_STACK_ITEM', { index: stackIndex, formCompleted: true }, { root: true });
    }
  },

  setFormSubmitted({ commit }, { state, stackIndex }) {
    commit('SET_FORM_SUBMITTED', state);

    if (state && stackIndex !== undefined) {
      commit('chatbotStore/UPDATE_STACK_ITEM', { index: stackIndex, formCompleted: true }, { root: true });
    }
  },

  resetForm({ commit }) {
    commit('RESET_FORM');
  },

  clearState({ commit }) {
    commit('RESET_FORM');
  },
};

export default {
  namespaced: true,
  registered: false,
  mutations,
  actions,
  state,
};
